import React, { useState, useEffect } from 'react';
import { Link, Typography, Box } from '@mui/material';
import { GetApp as GetAppIcon } from '@mui/icons-material';
import { InstallationOptionsScreen } from './InstallationOptionsScreen';
import { useDeviceDetection } from '../contexts/PWAContext';

export const InstallAppLink: React.FC = () => {
  const [showLink, setShowLink] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [hasInstallOptions, setHasInstallOptions] = useState(false);

  const deviceInfo = useDeviceDetection();

  useEffect(() => {
    // Calculate installation options
    const {
      isIOS,
      isAndroid,
      isDesktop,
      canInstallPWA,
      canInstallMobileApp,
      mobileAppCompatible,
      browser,
    } = deviceInfo;

    // Show link if there are any installation options available
    const hasOptions =
      canInstallPWA ||
      (canInstallMobileApp && mobileAppCompatible) ||
      (isIOS &&
        canInstallPWA &&
        (!mobileAppCompatible || browser !== 'Safari')) ||
      (isAndroid && canInstallPWA && !mobileAppCompatible) ||
      (isDesktop && canInstallPWA);

    setHasInstallOptions(hasOptions);
    setShowLink(hasOptions);
  }, [deviceInfo]);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    setShowOptions(true);
  };

  const handleCloseOptions = () => {
    setShowOptions(false);
  };

  // if (!showLink || !hasInstallOptions) {
  //   return null;
  // }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 0,
          mt: 0,
          paddingTop: '0px',
          paddingBottom: '0px',
        }}
      >
        <Link
          href="#"
          onClick={handleClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'primary.main',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          <GetAppIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
          <Typography variant="body2">Local Installation Options</Typography>
        </Link>
      </Box>

      <InstallationOptionsScreen
        open={showOptions}
        onClose={handleCloseOptions}
      />
    </>
  );
};
